class NoodCart extends HTMLElement {
  constructor() {
    super()

    this.root = window.Shopify.routes.root || '/'

    this.state = 'idle'

    this.$cartOpen = document.querySelectorAll('[data-cart-open]')
    this.$cartClose = this.querySelector('[data-cart-close]')
    this.$cartOverlay = this.parentElement.querySelector('[data-cart-overlay]')
    this.$cartScrollContainer = this.querySelector('[data-cart-scroll-container]')
    this.$cartTopBar = this.querySelector('[data-cart-top-bar]')

    this.$cartOpen.forEach((el) => el.addEventListener('click', this.open.bind(this)))
    this.$cartClose.addEventListener('click', this.close.bind(this))
    this.$cartOverlay.addEventListener('click', this.close.bind(this))

    this.initScrollTopShadow()
    this.initCheckoutSpinner()

    this.escapeHandler = (e) => {
      if (e.key === 'Escape') this.close()
    }

    // if (
    //   this.getCookie('getCart') != '' &&
    //   this.getCookie('getCart') == 'Yes' &&
    //   window.location.href.indexOf('cart') == -1 &&
    //   window.location.href.indexOf('pages') == -1 &&
    //   window.location.href.indexOf('account') == -1
    // ) {
    //   this.open({ getCart: false })
    // }

    const search = new URLSearchParams(window.location.search)
    const cartOpen = search.get('cartOpen')
    if (cartOpen !== null) this.open({ getCart: false })
  }

  // getCookie(cname) {
  //   var name = cname + '='
  //   var decodedCookie = document.cookie
  //   var ca = decodedCookie.split(';')
  //   for (var i = 0; i < ca.length; i++) {
  //     var c = ca[i]
  //     while (c.charAt(0) == ' ') {
  //       c = c.substring(1)
  //     }
  //     if (c.indexOf(name) == 0) {
  //       return c.substring(name.length, c.length)
  //     }
  //   }
  //   return ''
  // }

  // setCookie(cname, cvalue, exdays) {
  //   var d = new Date()
  //   d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  //   var expires = 'expires=' + d.toUTCString()
  //   document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
  // }

  async open(opts = {}) {
    if (opts.getCart !== false) await this.getCart()
    this.classList.remove('opacity-0', 'translate-x-full', 'pointer-events-none')
    this.classList.add('translate-x-0')
    this.$cartOverlay.classList.remove('opacity-0', 'pointer-events-none')
    document.body.classList.add('!overflow-hidden')
    this.classList.remove('invisible')
    trapFocus(this)

    document.addEventListener('keydown', this.escapeHandler)
  }

  close() {
    this.$cartOverlay.classList.add('opacity-0', 'pointer-events-none')
    this.classList.remove('translate-x-0')
    this.classList.add('opacity-0', 'translate-x-full', 'pointer-events-none')
    document.body.classList.remove('!overflow-hidden', 'js-drawer-open')
    document.documentElement.classList.remove('js-drawer-open')
    this.classList.add('invisible')
    removeTrapFocus(this)
    document.removeEventListener('keydown', this.escapeHandler)
    // if (this.getCookie('getCart') != '' && this.getCookie('getCart') == 'Yes') {
    //   this.setCookie('getCart', '')
    // }
    this.$cartOpen[0].focus()
  }

  setState(state) {
    this.state = state
    this.dispatchEvent(new CustomEvent('state-change', { detail: state }))
  }

  initCheckoutSpinner() {
    if (this.$checkout) return
    this.$checkout = this.querySelector('[data-checkout]')
    if (!this.$checkout) return
    this.$checkout.addEventListener('click', () => {
      const $spinner = this.$checkout.querySelector('svg')
      const $span = this.$checkout.querySelector('span')

      $span.classList.add('invisible')
      $spinner.classList.remove('hidden')

      setTimeout(() => {
        $span.classList.remove('invisible')
        $spinner.classList.add('hidden')
      }, 5000)
    })
  }

  async getCart() {
    // Uses the section rendering API to get a new cart
    if (this.state !== 'idle') return
    try {
      this.state = 'loading'
      const res = await fetch(`${this.root}?section_id=v2-cart&skipCache`)
      const htmlText = await res.text()

      try {
        this.update(htmlText)
      } catch (error) {
        console.error('Error parsing cart HTML', error)
      }
    } catch (error) {
      console.error('Error getting cart', error)
    } finally {
      this.state = 'idle'
    }
  }

  async changeCart(line, quantity) {
    if (this.state !== 'idle') return
    try {
      this.state = 'loading'
      const res = await fetch(`${this.root}cart/change?skipCache`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          line,
          quantity,
          sections: 'v2-cart',
        }),
      })
      const data = await res.json()
      try {
        this.update(data.sections['v2-cart'])
      } catch (error) {
        console.error('Error parsing cart HTML', error)
      }
    } catch (error) {
      console.error('Error changing cart', error)
    } finally {
      this.state = 'idle'
    }
  }

  async addToCart(opts = {}) {
    if (!opts.id) return

    if (this.state !== 'idle') return
    try {
      this.state = 'loading'
      const res = await fetch(`${this.root}cart/add?skipCache`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          ...opts,
          sections: 'v2-cart',
        }),
      })
      const data = await res.json()
      try {
        this.update(data.sections['v2-cart'])
      } catch (error) {
        console.error('Error parsing cart HTML', error)
      }
    } catch (error) {
      console.error('Error adding to cart', error)
    } finally {
      this.state = 'idle'
    }
  }

  update(html) {
    // const $$extendOffers = this.querySelectorAll('.extend-side-cart-offer')
    const newCartHtml = new DOMParser().parseFromString(html, 'text/html')

    // $$extendOffers.forEach(($el) => {
    //   const offerVariantId = $el.dataset.extendVariant
    //   newCartHtml
    //     .querySelectorAll(`cart-item[data-variant-id="${offerVariantId}"] div:nth-child(3)`)
    //     .forEach(($item) => {
    //       const clone = $el.cloneNode(true)
    //       $item.appendChild(clone)
    //     })
    // })

    window.morphdom(this, newCartHtml.querySelector('nood-cart'), {
      childrenOnly: true,
    })

    const $cartItemCountSource = this.querySelector('[data-cart-item-count-source]')
    const cartItemCount = $cartItemCountSource.dataset.cartItemCountSource
    const $cartItemCounts = document.querySelectorAll('[data-cart-item-count]')
    $cartItemCounts.forEach((el) => {
      if (cartItemCount > 0) {
        el.childNodes[0].textContent = cartItemCount
        el.classList.remove('invisible')
      } else {
        el.classList.add('invisible')
      }
    })

    this.initCheckoutSpinner()

    this.querySelectorAll('cart-upsell, cart-item, cart-free-gift, cart-gift-dropdown, cart-protocol-switch, cart-protocol-group').forEach(($el) => {
      $el.init()
    })

    // Affirm Handling (jsReady is not always a function depending on Affirm version / load state)
    const affirmJsReady = typeof window.affirm?.jsReady === 'function' ? window.affirm.jsReady.bind(window.affirm) : null
    if (affirmJsReady) {
      affirmJsReady(() => {
      const $affirmWrapper = this.querySelector('.affirm-wrapper')
      if ($affirmWrapper && window.affirm?.ui?.refresh) {
        const $affirmElement = $affirmWrapper.querySelector('.affirm-as-low-as')
        const observerCallback = (mutations, observer) => {
          mutations.forEach((mutation) => {
            if (mutation.type === 'childList') {
              const $affirmLink = $affirmWrapper.querySelector('.affirm-as-low-as a')
              const $affirmPriceElement = $affirmWrapper.querySelector('.affirm-ala-price')
              const $afirmModalTrigger = $affirmWrapper.querySelector('.affirm-modal-trigger')
              if (!$affirmLink || !$affirmPriceElement || !$afirmModalTrigger) return

              observer.disconnect()

              const $affirmAfterText = $affirmWrapper.querySelector('.affirm-after-text')
              if (!$affirmWrapper.hasAttribute('data-has-subscription')) {
                $affirmAfterText.classList.remove('text-orange')
                $affirmAfterText.classList.remove('font-bold')
                $affirmAfterText.classList.add('text-gray-2')
              }
              $affirmLink.before($affirmAfterText)

              $afirmModalTrigger.classList.add('text-orange', 'underline')
            }
          })
        }
        const observer = new MutationObserver(observerCallback)
        observer.observe($affirmElement, { childList: true })

        const affirmElements = document.querySelectorAll('.affirm-as-low-as')
        const cartAffirmElement = $affirmElement

        // Remove the class from all elements except the one in the cart
        affirmElements.forEach((element) => {
          // Skip the element if it's the one in the cart
          if (element !== cartAffirmElement && element.closest('nood-cart') !== this.closest('nood-cart')) {
            // Remove the class
            element.classList.remove('affirm-as-low-as')
          }
        })

        window.affirm.ui.refresh()

        // Add the affirm-as-low-as class back to elements after refresh
        setTimeout(() => {
          affirmElements.forEach((element) => {
            // Skip the element if it's the one in the cart
            if (element !== cartAffirmElement && element.closest('nood-cart') !== this.closest('nood-cart')) {
              element.classList.add('affirm-as-low-as')
            }
          })
        }, 500) // Wait for affirm UI refresh to complete
      }
      })
    }

    // Extend - Dispatch event when cart changes to update Extend
    window.dispatchEvent(new Event('refreshAjaxSideCart'))
    // Extend - End code
  }

  initScrollTopShadow() {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          this.$cartTopBar.classList.remove('shadow')
        } else {
          this.$cartTopBar.classList.add('shadow')
        }
      },
      { threshold: 1.0 }
    )

    // Create and observe a sentinel element at the top of the scroll container
    const sentinel = this.querySelector('[data-sentinel]')
    observer.observe(sentinel)
  }
}
customElements.define('nood-cart', NoodCart)

class CartItem extends HTMLElement {
  constructor() {
    super()
    this._onDecrease = this.decreaseQuantity.bind(this)
    this._onIncrease = this.increaseQuantity.bind(this)
    this.init()
  }

  init() {
    this.$cart = this.closest('nood-cart')

    this.state = 'idle'

    this.$decrease = this.querySelector('[data-decrease]')
    this.$increase = this.querySelector('[data-increase]')
    this.$quantity = this.querySelector('[data-quantity]')
    this.$loading = this.querySelector('[data-loading]')

    if (this.$decrease) {
      this.$decrease.removeEventListener('click', this._onDecrease)
      this.$decrease.addEventListener('click', this._onDecrease)
    }
    if (this.$increase) {
      this.$increase.removeEventListener('click', this._onIncrease)
      this.$increase.addEventListener('click', this._onIncrease)
    }

    if (this.shouldDisableIncrease()) {
      this.disableIncreaseButton()
    }
  }

  shouldDisableIncrease() {
    return this.hasAttribute('data-disable-increase')
  }

  disableIncreaseButton() {
    if (!this.$increase) return
    this.$increase.disabled = true
    this.$increase.setAttribute('aria-disabled', 'true')
    this.$increase.setAttribute('title', 'Quantity limited to 1')
    this.setAttribute('data-disable-increase', '')
  }

  isItemInProtocolGroup(item, parent, bundleKey) {
    if (!item || !parent || item.key === parent.key) return false

    const nestedUnderParent =
      item.parent_relationship &&
      (item.parent_relationship.parent_key === parent.key ||
        item.parent_relationship.parent?.key === parent.key)

    // Same bundle key only — never touch another protocol parent/group
    const sameBundle =
      bundleKey &&
      item.properties?._nood_bundle_key === bundleKey &&
      Boolean(item.parent_relationship)

    return Boolean(nestedUnderParent || sameBundle)
  }

  increaseQuantity() {
    if (this.shouldDisableIncrease() || this.$increase?.disabled) return
    if (this.state === 'loading') return

    const $quantity = this.querySelector('[data-quantity]')
    const currentQty = parseInt($quantity.textContent)
    this.setState('loading')

    // Protocol parent qty changes sync all linked children
    if (this.hasAttribute('data-protocol-parent') && this.dataset.bundleKey) {
      this.updateProtocolGroupQuantity(this.dataset.bundleKey, currentQty + 1)
      return
    }

    this.$cart.changeCart(this.dataset.line, currentQty + 1)
  }

  setState(state) {
    this.state = state
    if (state === 'loading') {
      this.$loading.classList.remove('!hidden')
    } else {
      this.$loading.classList.add('!hidden')
    }
  }

  decreaseQuantity() {
    if (this.state === 'loading') return

    const $quantity = this.querySelector('[data-quantity]')
    const currentQty = parseInt($quantity.textContent)
    if (currentQty > 0) {
      this.setState('loading')

      // Protocol parent qty changes sync all linked children
      if (this.hasAttribute('data-protocol-parent') && this.dataset.bundleKey) {
        this.updateProtocolGroupQuantity(this.dataset.bundleKey, currentQty - 1)
        return
      }

      this.$cart.changeCart(this.dataset.line, currentQty - 1)
    }
  }

  async updateProtocolGroupQuantity(bundleKey, quantity) {
    try {
      const cartRes = await fetch('/cart.js')
      const cart = await cartRes.json()
      const items = cart.items || []
      const parent = items.find(
        (item) => item.properties?._nood_bundle_key === bundleKey && !item.parent_relationship
      )
      if (!parent) {
        this.setState('idle')
        return
      }

      const updates = {
        [parent.key]: quantity,
      }

      // Only this group's nested children — leave the other protocol untouched
      items.forEach((item) => {
        if (this.isItemInProtocolGroup(item, parent, bundleKey)) {
          updates[item.key] = quantity
        }
      })

      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates }),
      })
      this.setState('idle')
      await this.$cart.getCart()
    } catch (error) {
      console.error('Failed to update protocol group quantity', error)
      this.setState('idle')
    }
  }
}
customElements.define('cart-item', CartItem)

const PROTOCOL_SWITCH_CHILDREN = {
  complete_protocol: [
    { id: 46536614248698, selling_plan: 4086989050, replenishes: true }, // Buff Bar
    { id: 46544263020794, selling_plan: 4087021818, replenishes: true }, // Shave Lube
    { id: 46544276062458, selling_plan: 4131717370, replenishes: true }, // Nood Razor
    { id: 46544247750906, selling_plan: 4042031354, replenishes: true }, // Nood Serum
  ],
  serum_protocol: [
    { id: 46544247750906, selling_plan: 4042031354, replenishes: true }, // Nood Serum
  ],
}

async function clearProtocolBundle(bundleKey) {
  if (!bundleKey) return
  const cartRes = await fetch('/cart.js')
  const cart = await cartRes.json()
  const updates = {}
  ;(cart.items || []).forEach((item) => {
    if (item.properties?._nood_bundle_key === bundleKey) {
      updates[item.key] = 0
    }
  })
  if (!Object.keys(updates).length) return
  await fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ updates }),
  })
}

async function addNestedProtocolToCart({ parentItem, childItems, bundleKey }) {
  const items = [
    parentItem,
    ...(childItems || []).map((child) => ({
      ...child,
      parent_id: parentItem.id,
    })),
  ]

  const response = await fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items }),
  })
  const data = await response.json()
  const added = Array.isArray(data.items) ? data.items : data?.id ? [data] : []

  if (!response.ok || data.status || added.length < items.length) {
    await clearProtocolBundle(bundleKey)
    throw new Error(data.description || data.message || 'Unable to add protocol to cart')
  }

  return data
}

class CartProtocolGroup extends HTMLElement {
  constructor() {
    super()
    this._onOptionChange = this.handleOptionChange.bind(this)
    this._onKeep = this.keepCurrent.bind(this)
    this._onUpdate = this.updateCartOption.bind(this)
    this._onRemove = (event) => {
      event.preventDefault()
      event.stopPropagation()
      this.removeGroup()
    }
    this._onOptionsToggle = this.handleOptionsToggle.bind(this)
    this._busy = false
    this.init()
  }

  init() {
    this.$cart = this.closest('nood-cart')
    this.$loading = this.querySelector('[data-loading]')
    this.$options = this.querySelector('[data-protocol-options]')
    this.$radios = this.querySelectorAll('[data-protocol-choice] input')
    this.$status = this.querySelector('[data-protocol-status]')
    this.$update = this.querySelector('[data-protocol-update]')
    this.$keep = this.querySelector('[data-protocol-keep]')
    this.$remove = this.querySelector('[data-protocol-remove]')

    this.$radios.forEach((radio) => {
      radio.removeEventListener('change', this._onOptionChange)
      radio.addEventListener('change', this._onOptionChange)
    })
    if (this.$keep) {
      this.$keep.removeEventListener('click', this._onKeep)
      this.$keep.addEventListener('click', this._onKeep)
    }
    if (this.$update) {
      this.$update.removeEventListener('click', this._onUpdate)
      this.$update.addEventListener('click', this._onUpdate)
    }
    if (this.$remove) {
      this.$remove.removeEventListener('click', this._onRemove)
      this.$remove.addEventListener('click', this._onRemove)
    }
    if (this.$options) {
      this.$options.removeEventListener('toggle', this._onOptionsToggle)
      this.$options.addEventListener('toggle', this._onOptionsToggle)
    }

    this.syncOptionUi()
  }

  setState(state) {
    if (!this.$loading) return
    this.$loading.classList.toggle('!hidden', state !== 'loading')
  }

  selectedChoice() {
    return this.querySelector('[data-protocol-choice] input:checked')?.closest('[data-protocol-choice]')
  }

  currentChoice() {
    return this.querySelector(`[data-protocol-choice][data-option="${this.dataset.protocolId}"]`)
  }

  handleOptionChange() {
    this.syncOptionUi()
  }

  handleOptionsToggle() {
    if (this.$options && !this.$options.open) this.resetRadios()
  }

  syncOptionUi() {
    const selected = this.selectedChoice()
    if (!selected) return

    const current = this.dataset.protocolId
    const selectedId = selected.dataset.option
    const label = selected.dataset.label
    const price = selected.dataset.price
    const isCurrent = selectedId === current
    const currentLabel = this.currentChoice()?.dataset.label || ''

    if (this.$status) {
      this.$status.textContent = isCurrent
        ? `Currently in cart: ${label} · ${price} today.`
        : `Selected: ${label} · ${price} today.`
    }

    if (this.$update) {
      this.$update.disabled = isCurrent
      this.$update.classList.toggle('is-disabled', isCurrent)
      const priceEl = this.$update.querySelector('[data-update-price]')
      if (priceEl) priceEl.textContent = price
    }

    if (this.$keep && currentLabel) {
      this.$keep.textContent = `Keep ${currentLabel}`
    }
  }

  resetRadios() {
    const currentRadio = this.currentChoice()?.querySelector('input')
    if (currentRadio) currentRadio.checked = true
    this.syncOptionUi()
  }

  keepCurrent() {
    if (this.$options) this.$options.open = false
    this.resetRadios()
  }

  createBundleKey() {
    return `nood_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 8)}`
  }

  buildLineProperties({ experimentArm, bundleKey, replenishes, offerChoice, protocolId }) {
    const props = {
      _nood_experiment_id: 'fp_protocol_v1',
      _nood_experiment_arm: experimentArm,
      _nood_offer_choice: offerChoice,
      _nood_protocol_id: protocolId,
      _nood_bundle_key: bundleKey,
    }
    if (replenishes) props._nood_replenishment_days = '60'
    return props
  }

  isItemInProtocolGroup(item, parent, bundleKey) {
    if (!item || !parent || item.key === parent.key) return false

    const nestedUnderParent =
      item.parent_relationship &&
      (item.parent_relationship.parent_key === parent.key ||
        item.parent_relationship.parent?.key === parent.key)

    const sameBundle = bundleKey && item.properties?._nood_bundle_key === bundleKey

    return Boolean(nestedUnderParent || sameBundle)
  }

  async getCartJson() {
    const cartRes = await fetch('/cart.js')
    return cartRes.json()
  }

  groupUpdates(items, parent, bundleKey) {
    const updates = { [parent.key]: 0 }
    items.forEach((item) => {
      if (this.isItemInProtocolGroup(item, parent, bundleKey)) {
        updates[item.key] = 0
      }
    })
    return updates
  }

  async updateCartOption() {
    const selected = this.selectedChoice()
    if (!selected || !this.$cart || this.$update?.disabled || this._busy) return

    const selectedId = selected.dataset.option
    const current = this.dataset.protocolId
    if (!selectedId || selectedId === current) return

    this._busy = true
    this.setState('loading')
    try {
      if (selectedId === 'device_only') {
        await this.switchToDeviceOnly()
      } else {
        await this.switchToProtocol(selectedId)
      }
    } catch (error) {
      console.error('Failed to update protocol option', error)
      this.setState('idle')
      await this.$cart.getCart()
    } finally {
      this._busy = false
    }
  }

  async switchToProtocol(experimentArm) {
    const cart = await this.getCartJson()
    const items = cart.items || []
    const parent = items.find((item) => item.key === this.dataset.parentKey)
    if (!parent) {
      this.setState('idle')
      await this.$cart.getCart()
      return
    }

    const resolvedArm =
      experimentArm === 'serum_protocol' || experimentArm === 'complete_protocol'
        ? experimentArm
        : this.dataset.experimentArm === 'serum_protocol'
          ? 'serum_protocol'
          : 'complete_protocol'
    const children = PROTOCOL_SWITCH_CHILDREN[resolvedArm] || PROTOCOL_SWITCH_CHILDREN.complete_protocol
    const bundleKey = this.createBundleKey()
    const quantity = parent.quantity || parseInt(this.dataset.quantity, 10) || 1
    const parentVariantId = parent.id
    const updates = this.groupUpdates(items, parent, parent.properties?._nood_bundle_key)

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        updates,
        attributes: {
          __nood_experiment_id: 'fp_protocol_v1',
          __nood_experiment_arm: resolvedArm,
        },
      }),
    })

    await addNestedProtocolToCart({
      bundleKey,
      parentItem: {
        id: parentVariantId,
        quantity,
        properties: this.buildLineProperties({
          experimentArm: resolvedArm,
          bundleKey,
          offerChoice: 'nood_society',
          protocolId: resolvedArm,
          replenishes: false,
        }),
      },
      childItems: children.map((child) => ({
        id: child.id,
        quantity,
        selling_plan: child.selling_plan,
        properties: this.buildLineProperties({
          experimentArm: resolvedArm,
          bundleKey,
          offerChoice: 'nood_society',
          protocolId: resolvedArm,
          replenishes: child.replenishes,
        }),
      })),
    })

    this.setState('idle')
    await this.$cart.getCart()
  }

  async switchToDeviceOnly() {
    const cart = await this.getCartJson()
    const items = cart.items || []
    const parent = items.find((item) => item.key === this.dataset.parentKey)
    if (!parent) {
      this.setState('idle')
      await this.$cart.getCart()
      return
    }

    const experimentArm =
      this.dataset.experimentArm === 'serum_protocol' ? 'serum_protocol' : 'complete_protocol'
    const bundleKey = this.createBundleKey()
    const quantity = parent.quantity || parseInt(this.dataset.quantity, 10) || 1
    const parentVariantId = parent.id
    const updates = this.groupUpdates(items, parent, parent.properties?._nood_bundle_key)

    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        updates,
        attributes: {
          __nood_experiment_id: 'fp_protocol_v1',
          __nood_experiment_arm: experimentArm,
        },
      }),
    })

    const addRes = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [
          {
            id: parentVariantId,
            quantity,
            properties: this.buildLineProperties({
              experimentArm,
              bundleKey,
              offerChoice: 'one_time',
              protocolId: 'device_only',
              replenishes: false,
            }),
          },
        ],
      }),
    })
    const addData = await addRes.json()
    if (!addRes.ok || addData.status) {
      throw new Error(addData.description || addData.message || 'Unable to switch to device only')
    }

    this.setState('idle')
    await this.$cart.getCart()
  }

  async removeGroup() {
    if (!this.$cart || this._busy) return
    this._busy = true
    this.setState('loading')
    try {
      const cart = await this.getCartJson()
      const items = cart.items || []
      const parent = items.find((item) => item.key === this.dataset.parentKey)
      if (!parent) {
        this.setState('idle')
        await this.$cart.getCart()
        return
      }

      const updates = this.groupUpdates(items, parent, parent.properties?._nood_bundle_key)
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates }),
      })
      this.setState('idle')
      await this.$cart.getCart()
    } catch (error) {
      console.error('Failed to remove protocol group', error)
      this.setState('idle')
      await this.$cart.getCart()
    } finally {
      this._busy = false
    }
  }
}
customElements.define('cart-protocol-group', CartProtocolGroup)

class CartProtocolSwitch extends HTMLElement {
  constructor() {
    super()
    this._onSwitchClick = this.switchToProtocol.bind(this)
    this.init()
  }

  init() {
    this.$cart = this.closest('nood-cart')
    this.$loading = this.querySelector('[data-loading]')
    this.$button = this.querySelector('[data-protocol-switch]')
    if (this.$button) {
      this.$button.removeEventListener('click', this._onSwitchClick)
      this.$button.addEventListener('click', this._onSwitchClick)
    }
  }

  setState(state) {
    if (!this.$loading) return
    this.$loading.classList.toggle('!hidden', state !== 'loading')
    if (this.$button) this.$button.disabled = state === 'loading'
  }

  createBundleKey() {
    return `nood_${Date.now().toString(36)}_${Math.random().toString(36).slice(2, 8)}`
  }

  buildLineProperties({ experimentArm, bundleKey, replenishes }) {
    const props = {
      _nood_experiment_id: 'fp_protocol_v1',
      _nood_experiment_arm: experimentArm,
      _nood_offer_choice: 'nood_society',
      _nood_protocol_id: experimentArm,
      _nood_bundle_key: bundleKey,
    }
    if (replenishes) props._nood_replenishment_days = '60'
    return props
  }

  async switchToProtocol() {
    if (!this.$cart || this.$button?.disabled) return
    this.setState('loading')

    try {
      const cartRes = await fetch('/cart.js')
      const cart = await cartRes.json()
      const items = cart.items || []

      const deviceOnly = items.find(
        (item) =>
          item.properties?._nood_protocol_id === 'device_only' && !item.parent_relationship
      )
      if (!deviceOnly) {
        this.setState('idle')
        await this.$cart.getCart()
        return
      }

      const experimentArm =
        deviceOnly.properties?._nood_experiment_arm ||
        this.dataset.experimentArm ||
        cart.attributes?.__nood_experiment_arm ||
        'complete_protocol'
      const resolvedArm =
        experimentArm === 'serum_protocol' || experimentArm === 'complete_protocol'
          ? experimentArm
          : 'complete_protocol'
      const children = PROTOCOL_SWITCH_CHILDREN[resolvedArm] || PROTOCOL_SWITCH_CHILDREN.complete_protocol
      const bundleKey = this.createBundleKey()
      const quantity = deviceOnly.quantity || 1
      const parentVariantId = deviceOnly.id

      // Remove device-only line first
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          updates: { [deviceOnly.key]: 0 },
          attributes: {
            __nood_experiment_id: 'fp_protocol_v1',
            __nood_experiment_arm: resolvedArm,
          },
        }),
      })

      await addNestedProtocolToCart({
        bundleKey,
        parentItem: {
          id: parentVariantId,
          quantity,
          properties: this.buildLineProperties({
            experimentArm: resolvedArm,
            bundleKey,
            replenishes: false,
          }),
        },
        childItems: children.map((child) => ({
          id: child.id,
          quantity,
          selling_plan: child.selling_plan,
          properties: this.buildLineProperties({
            experimentArm: resolvedArm,
            bundleKey,
            replenishes: child.replenishes,
          }),
        })),
      })

      this.setState('idle')
      await this.$cart.getCart()
    } catch (error) {
      console.error('Failed to switch to protocol', error)
      this.setState('idle')
      await this.$cart.getCart()
    }
  }
}
customElements.define('cart-protocol-switch', CartProtocolSwitch)

class CartUpsell extends HTMLElement {
  constructor() {
    super()

    this.init()
  }

  init() {
    this.$cart = this.closest('nood-cart')

    this.state = 'idle'
    this.$loading = this.querySelector('[data-loading]')

    this.$add = this.querySelector('[data-cart-upsell-add]')
    this.$add.addEventListener('click', this.add.bind(this))

    this.$primaryImage = this.querySelector('[data-primary-image]')
    this.$productLinks = this.querySelectorAll('[data-product-link]')
    this.$variantTitle = this.querySelector('[data-variant-title]')

    this.addEventListener('change', this.handleColorChange.bind(this))
  }

  handleColorChange(e) {
    const $swatch = e.target
    const variantId = $swatch.getAttribute('data-variant-id')
    if (variantId) {
      this.$primaryImage.classList.add('opacity-0')
      const otherVariantImages = this.querySelectorAll(`[data-variant-image]:not([data-variant-image="${variantId}"])`)
      otherVariantImages.forEach((image) => {
        image.classList.add('opacity-0')
      })

      const variantImage = this.querySelector(`[data-variant-image="${variantId}"]`)
      variantImage.classList.remove('opacity-0')
    } else {
      const variantImages = this.querySelectorAll('[data-variant-image]')
      variantImages.forEach((image) => {
        image.classList.add('opacity-0')
      })

      this.$primaryImage.classList.remove('opacity-0')
    }

    this.$variantTitle.textContent = $swatch.value

    this.$add.dataset.variantId = variantId
  }

  setState(state) {
    this.state = state
    if (state === 'loading') {
      this.$loading.classList.remove('!hidden')
    } else {
      this.$loading.classList.add('!hidden')
    }
  }

  add() {
    this.setState('loading')
    this.$cart.addToCart({
      id: parseInt(this.$add.dataset.variantId),
      quantity: 1,
      ...(this.$add.dataset.sellingPlanId ? { selling_plan: parseInt(this.$add.dataset.sellingPlanId) } : {}),
    })
  }
}
customElements.define('cart-upsell', CartUpsell)

class CartFreeGift extends HTMLElement {
  constructor() {
    super()
    this._onAddClick = this.add.bind(this)
    this._onToggleDetailsClick = this.toggleDetails.bind(this)
    this.init()
  }

  init() {
    this.$cart = this.closest('nood-cart')

    this.state = 'idle'
    this.$loading = this.querySelector('[data-loading]')
    this.$addText = this.querySelector('[data-add-text]')
    this.$addIcon = this.querySelector('[data-add-icon]')

    this.$add = this.querySelector('[data-cart-free-gift-add]')
    if (this.$add) {
      this.$add.removeEventListener('click', this._onAddClick)
      this.$add.addEventListener('click', this._onAddClick)
    }

    this.detailsOpen = false
    this.$detailsToggle = this.querySelector('[data-gift-card-details-toggle]')
    this.$details = this.querySelector('[data-gift-card-details]')
    this.$labelMore = this.querySelector('[data-gift-see-more-label]')
    this.$labelLess = this.querySelector('[data-gift-see-less-label]')
    this.$chevron = this.querySelector('[data-gift-chevron]')
    if (this.$detailsToggle && this.$details) {
      this.$detailsToggle.removeEventListener('click', this._onToggleDetailsClick)
      this.$detailsToggle.addEventListener('click', this._onToggleDetailsClick)
      this.$details.classList.remove('is-open')
      this.$detailsToggle.setAttribute('aria-expanded', 'false')
      if (this.$labelMore) this.$labelMore.classList.remove('hidden')
      if (this.$labelLess) this.$labelLess.classList.add('hidden')
      if (this.$chevron) this.$chevron.classList.remove('rotate-180')
    }
  }

  _refreshGiftDropdownHeight() {
    const dropdown = this.closest('cart-gift-dropdown')
    if (!dropdown || typeof dropdown.refreshHeight !== 'function') return
    dropdown.refreshHeight()
    requestAnimationFrame(() => {
      dropdown.refreshHeight()
      requestAnimationFrame(() => dropdown.refreshHeight())
    })
    window.setTimeout(() => dropdown.refreshHeight(), 360)
  }

  toggleDetails(event) {
    event.preventDefault()
    event.stopPropagation()
    this.detailsOpen = !this.detailsOpen
    this.$details.classList.toggle('is-open', this.detailsOpen)
    this.$detailsToggle.setAttribute('aria-expanded', this.detailsOpen ? 'true' : 'false')
    if (this.$labelMore) this.$labelMore.classList.toggle('hidden', this.detailsOpen)
    if (this.$labelLess) this.$labelLess.classList.toggle('hidden', !this.detailsOpen)
    if (this.$chevron) this.$chevron.classList.toggle('rotate-180', this.detailsOpen)
    this._refreshGiftDropdownHeight()
  }

  setState(state) {
    this.state = state
    if (state === 'loading') {
      this.$addText?.classList.add('invisible')
      this.$addIcon?.classList.add('invisible')
      this.$loading?.classList.remove('!hidden')
    } else {
      this.$addText?.classList.remove('invisible')
      this.$addIcon?.classList.remove('invisible')
      this.$loading?.classList.add('!hidden')
    }
  }

  add() {
    const variantId = parseInt(this.dataset.variantId)
    if (!variantId || isNaN(variantId)) {
      console.error('Invalid variant ID:', this.dataset.variantId)
      return
    }

    this.setState('loading')
    this.$cart.addToCart({
      id: variantId,
      quantity: 1,
      properties: { _gift_from_cart: 'true' },
    })
  }
}
customElements.define('cart-free-gift', CartFreeGift)

class CartGiftDropdown extends HTMLElement {
  constructor() {
    super()
    this._handleClick = this.toggle.bind(this)
    this.init()
  }

  init() {
    this.$toggle = this.querySelector('[data-gift-dropdown-toggle]')
    this.$content = this.querySelector('[data-gift-dropdown-content]')
    this.$icon = this.querySelector('[data-gift-dropdown-icon]')
    this.isOpen = false

    if (this.$toggle) {
      this.$toggle.removeEventListener('click', this._handleClick)
      this.$toggle.addEventListener('click', this._handleClick)
    }
  }

  toggle() {
    this.isOpen ? this.close() : this.open()
  }

  open() {
    if (!this.$content) return
    this.isOpen = true
    this.$content.style.maxHeight = this.$content.scrollHeight + 'px'
    if (this.$toggle) this.$toggle.setAttribute('aria-expanded', 'true')
    if (this.$icon) this.$icon.textContent = '\u2212'
  }

  close() {
    if (!this.$content) return
    this.isOpen = false
    this.$content.style.maxHeight = '0px'
    if (this.$toggle) this.$toggle.setAttribute('aria-expanded', 'false')
    if (this.$icon) this.$icon.textContent = '+'
  }

  refreshHeight() {
    if (!this.$content || !this.isOpen) return
    this.$content.style.maxHeight = this.$content.scrollHeight + 'px'
  }
}
customElements.define('cart-gift-dropdown', CartGiftDropdown)
